import type { PatientFindingView } from '@app/icare/entities/patientFinding/schema/PatientFinding'
import { Badge, type BadgeProps, Tooltip, type TooltipProps } from 'antd'
import { FindingsMessages } from './FindingsMessages'

interface FindingsBadgeProps extends Omit<BadgeProps, 'count'> {
  findings?: PatientFindingView[]
  className?: string
  tooltipPlacement?: TooltipProps['placement']
}

export function FindingsBadge(props: FindingsBadgeProps) {
  const { tooltipPlacement, findings = [], className, children, ...badgeProps } = props
  if (!findings || findings.length === 0) {
    return children
  }

  return (
    <Tooltip placement={tooltipPlacement ?? 'bottom'} color="white" title={<FindingsMessages findings={findings} />}>
      <Badge
        title=""
        {...badgeProps}
        className={className}
        count={findings.length}
        children={children}
        status="error"
        size="small"
      />
    </Tooltip>
  )
}
